Drupal.behaviors.sw_form_provider_search = {
  attach: function( context, settings ) {
    $('.form-provider-search').sw_form_provider_search();
  }
};

$.fn.sw_form_provider_search= function() {
  let m;
  $(this).each(function() {
    m = $(this).data('sw-form-provider-search');
    if ( !m ) {
      m = new SwFormProviderSearch($(this));
    }
  });
  return m;
};

class SwFormProviderSearch {

  constructor($w) {
    const _this = this;

    this.$w = $w;
    this.id = this.$w.data('id');
    this.$webform_element = $('#'+this.id);
    this.$autoselect_wrap = this.$w.find('.form-provider-search__autoselect-wrap');
    this.$selects = this.$w.find('.form-provider-search__select');
    this.$search_input = this.$w.find('input[name="name"]');
    this.$search_submit = this.$w.find('input[name="op_search"]');
    if ( !this.id || !this.$webform_element.length ) {
      this.$selects.hide();
    }

    this.$selects.on('click', function(e) {
      e.preventDefault();
      const data = $(this).data('select');
      const wcp = _this.$webform_element.sw_webform_connecture_provider();
      wcp.select_fill(data);
      _this.close_dialog();
    });

    this.$w.on('click', 'a[href="#manual-input"]', function( e ) {
      e.preventDefault();
      const wcp = _this.$webform_element.sw_webform_connecture_provider();
      wcp.manual_init();
      wcp.manual_flash();
      _this.close_dialog();
    });

    this.$search_input.on('autocompleteselect', function() {
      setTimeout(function() {
        _this.$search_submit.trigger('mousedown');
        _this.$search_submit.blur();
      },50);
    });

    setTimeout(function() {
      _this.check_auto_select();
    }, 500);

    this.$w.data('sw-form-provider-search', this);
  }

  close_dialog() {
    const $close = this.$w.closest('.ui-dialog').find('.ui-dialog-titlebar-close');
    $close.trigger('click');
  }

  check_auto_select() {
    if ( this.$autoselect_wrap.length ) {
      const $auto_selects = this.$autoselect_wrap.find('.form-provider-search__select');
      if( $auto_selects.length === 1 ) {
        $auto_selects.first().trigger('click');
      }
    }
  }
}


